
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/faqs/[faqProduct]",
      function () {
        return require("private-next-pages/faqs/[faqProduct].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/faqs/[faqProduct]"])
      });
    }
  